export function arraysEqual<T = any>(
  a: T[] | null | undefined,
  b: T[] | null | undefined,
): boolean {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;
  return a.every((v, i) => v === b[i]);
}
export function objEqualShallow<T = Object>(
  a: T | null | undefined,
  b: T | null | undefined,
): boolean {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (Object.keys(a).length !== Object.keys(b).length) return false;
  return Object.keys(a).every((key) => a[key] === b[key]);
}
